import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ActionState } from '../../types/action-center-types';

@Component({
    selector: 'sales-opportunity-box',
    templateUrl: './sales-opportunity-box.component.html',
    styleUrls: ['./sales-opportunity-box.component.scss'],
    standalone: false
})
export class SalesOpportunityBoxComponent implements OnInit {

  @Input() currPageState: ActionState | undefined;
  @Input() dollarValue: number | undefined;

  constructor() { }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges) { }

  displayDollarValue(): string {
    return this.dollarValue ? this.dollarValue.toString() : '';
  }
}
